import {creates, hoistCmp} from '@xh/hoist/core';
import {Level2WidgetModel} from './Level2WidgetModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import './Level2Widget.scss';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {securityPicker} from '../../../../cmp/securityPicker/SecurityPicker';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';

export const level2Widget = hoistCmp.factory({
    className: 'level2-widget',
    model: creates(Level2WidgetModel),
    render({model, className}) {
        return panel({
            className,
            tbar: tbar(),
            item: grid({agOptions: model.agOptions})
        });
    }
});

const tbar = hoistCmp.factory<Level2WidgetModel>({
    render({model}) {
        return toolbar({
            className: 'highcharts-bindings-wrapper',
            compact: true,
            items: [
                securityPicker({
                    ticker: model.ticker,
                    disabled: model.isTickerLinked,
                    onSecuritySelected: sec => model.setTicker(sec.ticker),
                    width: 100,
                    showSearchIcon: true,
                    keepSelection: true
                }),

                button({
                    icon: Icon.link(),
                    intent: model.isTickerLinked ? 'warning' : null,
                    active: model.isTickerLinked,
                    onClick: () => model.toggleLinked(),
                    tooltip: 'Link to main chart'
                })
            ]
        });
    }
});
